import { Notify } from "@flexisaf/flexibull2";
import { DEFAULT_ERROR_MESSAGE, ERROR, SUCCESS, TOP_RIGHT } from "./constants";

const getLocalItem = (item) => localStorage.getItem(item);

const setLocalItem = (item, value) => localStorage.setItem(item, value);

const clearLocalItem = (item) => localStorage.clear(item);

export const getLocalAccessToken = () => getLocalItem("access_token");
export const getLocalRefreshToken = () => getLocalItem("refresh_token");
export const getLocalUser = () => JSON.parse(getLocalItem("current_user"));

export const setLocalAccessToken = (value) =>
  setLocalItem("access_token", value);
export const setLocalRefreshToken = (value) =>
  setLocalItem("refresh_token", value);
export const setLocalUser = (value) => setLocalItem("current_user", value);

export const clearLocalAccessToken = () => clearLocalItem("access_token");
export const clearLocalRefreshToken = () => clearLocalItem("refresh_token");
export const clearLocalUser = () => clearLocalItem("current_user");

export const logout = () => {
  clearLocalAccessToken();
  clearLocalRefreshToken();
  clearLocalUser();
};

export const calculateOffset = (page, pageSize) => {
  const offSet = (page - 1) * pageSize;
  return offSet;
};

export const getUrlParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

export const successNotifier = (message) => {
  Notify(message || DEFAULT_ERROR_MESSAGE, {
    position: TOP_RIGHT,
    status: SUCCESS,
  });
};

export const thousandFormatter = (num) => new Intl.NumberFormat().format(num);

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export const errorNotifier = (message) => {
  Notify(message || DEFAULT_ERROR_MESSAGE, {
    position: TOP_RIGHT,
    status: ERROR,
  });
};

// Helpers for exam group
export const findExamGroupFromName = (examGroups, name) => {
  const foundGroup = examGroups?.find((group) => group?.name === name);

  return foundGroup || null;
};

// Helpers for exam
export const findExamFromName = (exams, name) => {
  const foundExam = exams?.find((group) => group?.name === name);

  return foundExam || null;
};

export const findIndexInArray = (originalArray, objectToFInd, key, key2) => {
  return originalArray.findIndex((item) => {
    if (key2) return item[key][key2] === objectToFInd[key][key2];
    else return item[key] === objectToFInd[key];
  });
};

export const returnUpdatedList = (newObj, oldList, key = "id", key2 = "") => {
  const indexOfLocal = findIndexInArray(oldList, newObj, key, key2);
  if (indexOfLocal !== -1) oldList[indexOfLocal] = newObj;
  return oldList;
};
